import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { MapOptions, Map, latLng, tileLayer } from "leaflet";
import { Observable, Subscriber } from "rxjs";
import { ObservationService } from "../service/observation.service";
import { MatDialog } from "@angular/material/dialog";
import { DialogDetailsComponent } from "../../widget/dialog-details/dialog-details.component";
import { AuthService } from "../../auth/service/auth.service";
import { UserService } from "../../user/service/user.service";

@Component({
  selector: "app-observation-item",
  templateUrl: "./observation-item.component.html",
  styleUrls: ["./observation-item.component.css"],
})
export class ObservationItemComponent implements OnInit {
  @Input() id!: string;

  indexImg!: number;
  mainImg!: string;
  images!: any[];
  constructor(
    private observationService: ObservationService,
    private router: Router,
    public dialog: MatDialog,
  ) { }

  varietyObservationObs$!: Observable<any>;

  varObvActivitiesObs!: Observable<any>;
  varObvLastObs!: Observable<any>;


  // user_id!: any;

  ngOnInit(): void {
    this.fnObservable(this.id);
    this.fnGetActivities(this.id);
    // this.fnGetLastObs();
  }

  fnObservable(id: string) {
    this.indexImg = 0;
    this.varietyObservationObs$ = this.observationService.getCatalogInfo(id);
    this.varietyObservationObs$.subscribe((_obj: any) => {
      if (_obj.success) {


        // this.user_id = _obj.data.user_id;

        this.fnGetLastObs(_obj.data.user_id);

        if (_obj.data.images?.length > 0) {
          this.images = _obj.data.images;
          this.mainImg = _obj.data.images[this.indexImg].image_url;
        } else {
          this.images = [
            {
              image_url:
                "https://wikipapa.org/images/img-no-disponible-large.jpg",
            },
          ];
          this.mainImg = this.images[this.indexImg].image_url;
        }
      }
    });
  }

  fnItem(id: string | null, is_original: boolean) {
    if (is_original) {
      // this.router.navigate(["/catalogo-item", id]);

      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate(["/catalogo-item", id]).then(() => {
        })
      })

    }
    else {
      const _width = '900';
      // if (this.variety_id) {
      const _dialogRef = this.dialog.open(DialogDetailsComponent, {
        width: _width + "px",
        data: { variety_id: id },
      });
      // }

    }
  }

  fnGoObs(id: string) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(["/observacion", id]).then(() => {
      })
    })
  }

  time_ago(time: any) {
    switch (typeof time) {
      case "number":
        break;
      case "string":
        time = +new Date(time);
        break;
      case "object":
        if (time.constructor === Date) time = time.getTime();
        break;
      default:
        time = +new Date();
    }
    var time_formats = [
      [60, "segundos", 1], // 60
      [120, "1 minuto atrás", "1 minuto desde ahora"], // 60*2
      [3600, "minutos", 60], // 60*60, 60
      [7200, "1 hora atrás", "1 hora desde ahora"], // 60*60*2
      [86400, "horas", 3600], // 60*60*24, 60*60
      [172800, "Ayer", "Mañana"], // 60*60*24*2
      [604800, "días", 86400], // 60*60*24*7, 60*60*24
      [1209600, "Última semana", "Siguiente semana"], // 60*60*24*7*4*2
      [2419200, "semanas", 604800], // 60*60*24*7*4, 60*60*24*7
      [4838400, "Último mes", "Siguiente mes"], // 60*60*24*7*4*2
      [29030400, "meses", 2419200], // 60*60*24*7*4*12, 60*60*24*7*4
      [58060800, "Último año", "Siguiente año"], // 60*60*24*7*4*12*2
      [2903040000, "años", 29030400], // 60*60*24*7*4*12*100, 60*60*24*7*4*12
      [5806080000, "Último siglo", "Siguiente siglo"], // 60*60*24*7*4*12*100*2
      [58060800000, "siglos", 2903040000], // 60*60*24*7*4*12*100*20, 60*60*24*7*4*12*100
    ];

    let seconds = (+new Date() - time) / 1000,
      token = "atrás",
      list_choice = 1;

    if (seconds == 0) {
      return "Justo ahora";
    }
    if (seconds < 0) {
      seconds = Math.abs(seconds);
      token = "desde ahora";
      list_choice = 2;
    }

    // let i = 0, format;
    // let i = 0;
    // let format = [];
    // while ((format = time_formats[i++])) {
    //   let format_num = format[0];
    //   let seconds_text = seconds;
    //   if (seconds < format_num) {
    //     if (typeof format[2] == "string") return format[list_choice];
    //     else
    //       return (
    //         Math.floor(seconds / format[2]) + " " + format[1] + " " + token
    //       );
    //   }
    // }

    time_formats.forEach(format => {
      if (typeof format[0] == "number") {
        let format_num = format[0];
        if (seconds < format_num) {
          if (typeof format[2] == "string") return format[list_choice];
          else
            return (
              Math.floor(seconds / format[2]) + " " + format[1] + " " + token
            );
        }
      }
    });
    return time;
  }



  fnGetActivities(id: string) {
    this.varObvActivitiesObs =
      this.observationService.getActivityObservation(id);
  }

  fnGetLastObs(_user_id: any) {

    const _var = {
      page: null,
      page_size: 6,
      variety_name: null,
      country: null,
      region: null, // this.region_control.value,
      farmer_name: null,

      province: null,
      district: null,
      locality: null,

      observation_date: null,
      observation_date_start: null,
      observation_date_end: null,
      user_id: _user_id,
      is_public: true,

      varietal_group: null,
      farmer_id: null,
      is_original: null,
      months: null,
      sort_by: 'observation_date',
    };


    this.varObvLastObs =
      this.observationService.getSearch(_var);
    const varObvLastSubs = this.varObvLastObs.subscribe();

  }

  fnGoToView(_route: string, _user_id: string, _username: string) {
    const _params = {
      p_user_id: _user_id,
      p_username: _username
    };

    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([_route], {
        queryParams: _params
      }).then(() => {
      });
    });
  }

}
